export default __webpack_public_path__ + "static/media/broken.cf285764.png";